'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _last = require('lodash/last');

var _last2 = _interopRequireDefault(_last);

var _includes = require('lodash/includes');

var _includes2 = _interopRequireDefault(_includes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HOSTS = {
  SCHOOLTUBE: 'www.schooltube.com',
  TEACHERTUBE: 'www.teachertube.com',
  VIMEO: 'player.vimeo.com',
  YOUTUBE: 'www.youtube.com'
};

var substituteProtocol = function substituteProtocol(url) {
  return url.replace(/.*\/\//, 'https://');
};
var lastPathSegment = function lastPathSegment(url) {
  return (0, _last2.default)(url.split('/'));
};
var removeQuery = function removeQuery(url) {
  return url.split('?')[0];
};

/**
 * Validates a URL using a modified version of the @stephenhay regex from http://mathiasbynens.be/demo/url-regex
 * @param  {string} url
 * @return {boolean}
 */
var isUrl = function isUrl(url) {
  return (/^(https?|ftp):\/\/[^\s/$.?:#]+\.[^\s]*$/i.test(url)
  );
};

/**
 * Returns the host part of a url.
 */
var getHost = function getHost(url) {
  return (url.match(/:\/\/([^/]*)/) || [])[1];
};

/**
 * Extracts a src="..." URL from a string like <iframe src="some_url">
 * @param  {string} str
 * @return {string|undefined}
 */
function fromIframeSrc(str) {
  var match = str.match(/src=["']([^"']*)["']/);
  return (match || [])[1];
}

/**
 * Converts a video URL to the embedded player URL of the relevant video service.
 * Supported: vimeo, youtube, google drive
 *
 * @param  {string} videoUrl
 * @return {string}
 */
function urlToIFrameSrc(videoUrl) {
  if (!videoUrl) return '';

  var url = void 0;
  url = fromIframeSrc(videoUrl) || videoUrl;
  url = substituteProtocol(url);

  // Sanity check that we know what we're parsing
  if (!isUrl(url)) return '';

  if (url.match(/vimeo/)) {
    return 'https://' + HOSTS.VIMEO + '/video/' + url.match(/[0-9]+/);
  }

  if (url.match(/youtu(\.?)be/)) {
    var videoId = '';
    if (/\?v=|\/v\//.test(url)) {
      videoId = url.split(/\?v=|\/v\//)[1];
    } else {
      videoId = removeQuery(lastPathSegment(url));
    }

    return 'https://' + HOSTS.YOUTUBE + '/embed/' + videoId;
  }

  if (url.match(/teachertube/)) {
    return 'https://' + HOSTS.TEACHERTUBE + '/embed/video/' + url.match(/[0-9]+/)[0];
  }

  if (url.match(/schooltube/)) {
    var match = url.match(/www\.schooltube\.com\/(video|embed_force)\/([^/]*)/i);
    return match ? 'https://' + HOSTS.SCHOOLTUBE + '/embed_force/' + match[2] : '';
  }

  // No matching transformation
  return '';
}

// Decorate urlToIFrameSrc() with a whitelisting check, to ensure that the
// returned URL matches a known video host. Cf CORE-37097.

exports.default = function (url) {
  var src = urlToIFrameSrc(url);
  return src && (0, _includes2.default)(HOSTS, getHost(src)) ? src : '';
};


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/utils-ugc/lib/video/urlToIFrameSrc.js
// module id = 1569
// module chunks = 1